import { render, staticRenderFns } from "./OrderOverview.vue?vue&type=template&id=96a7adfe&scoped=true&"
import script from "./OrderOverview.vue?vue&type=script&lang=ts&"
export * from "./OrderOverview.vue?vue&type=script&lang=ts&"
import style0 from "./OrderOverview.vue?vue&type=style&index=0&id=96a7adfe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96a7adfe",
  null
  
)

export default component.exports